import { yupResolver } from "@hookform/resolvers/yup";
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";
import RemoveOutlinedIcon from "@mui/icons-material/RemoveOutlined";
import { Box, Grid, Modal } from "@mui/material";
import { format } from "date-fns";
import * as React from "react";
import { useFieldArray, useForm } from "react-hook-form";
import * as yup from "yup";
import {
  getAdvancedDropdown,
  getBankList,
  getBillingAdvanceDetails,
  getPaymentMode,
  getUpiType,
} from "../../../../billing/services/BillingServices";
import CancelPresentationIconButton from "../../../../common/components/Buttons/CancelPresentationIconButton";
import CommonButton from "../../../../common/components/Buttons/CommonButton";
import CommonBackDrop from "../../../../common/components/CommonBackDrop/CommonBackDrop";
import ConfirmationModal from "../../../../common/components/ConfirmationModal";
import DatePickerFieldNew from "../../../../common/components/FormFields/DatePickerFieldNew";
import DropdownField from "../../../../common/components/FormFields/DropdownField";
import InputField from "../../../../common/components/FormFields/InputField";
import CommonTransactionTable from "../../../../common/components/CommonTable/CommonTransactionTable";
//style for model
const ModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "95%",
  bgcolor: "background.paper",
  border: "1px solid gray",

  boxShadow: 20,
  p: 2,
};
export default function BillInformationModal(props) {
  const {
    paymentInfo,
    setPaymentInfo,
    billAdvanceDetailsList,
    setBillAdvanceDetailsList,
    totalConsumeAmount,
    setTotalConsumeAmount,
  } = props;
  /****************************** useForm ********************************/
  let paymentSchema = {
    paymentCart: yup
      .array()
      .of(
        yup.object().shape({
          upiname: yup
            .object()
            .nullable()
            .required(" ")
            .shape({
              value: yup.string(),
              label: yup.string(),
            })
            .when("paymentMode", (paymentMode) => {
              let paymentModeName;

              if (paymentMode) {
                paymentModeName = paymentMode.label;
              }

              if (paymentModeName === "UPI") {
                return yup
                  .object()
                  .required(" ")
                  .nullable()
                  .shape({
                    value: yup.string().required(" "),
                    label: yup.string().required(" "),
                  });
              } else {
                return yup
                  .object()
                  .notRequired()
                  .nullable()
                  .shape({
                    value: yup.string().notRequired(),
                    label: yup.string().notRequired(),
                  })
                  .notRequired();
              }
            }),
          amount: yup
            .number()
            .typeError("Amount Required")
            .min(0, "Min value 1.")
            .required("Amount Required"),

          paymentMode: yup
            .object()
            .nullable()
            .shape({
              value: yup.string().required("Required"),
              label: yup.string().required("Required"),
            })
            .required("Required"),

          referenceNumber: yup.string().when("paymentMode", (paymentMode) => {
            let paymentModeName;

            if (paymentMode) {
              paymentModeName = paymentMode.label;
            }

            if (
              paymentModeName === "CREDIT CARD" ||
              paymentModeName === "DEBIT CARD"
            ) {
              return yup
                .string()
                .required("Required")
                .matches(/^[0-9a-zA-Z]+$/, "Must be alphanumeric.")
                .min(4)
                .max(30);
            } else if (paymentModeName === "UPI") {
              return yup
                .string()
                .required("Reference Number Required")
                .matches(/^[0-9a-zA-Z]+$/, "Must be alphanumeric.")
                .min(1)
                .max(30);
              // .length(20, "Only 6 Digits allowed");
            } else if (paymentModeName === "CHEQUE") {
              return yup
                .string()
                .required("Reference Number Required")
                .max(30, "Only 6 Digits allowed");
            } else if (paymentModeName === "ECS") {
              return yup
                .string()
                .required("Reference Number Required")
                .matches(/^[0-9a-zA-Z]+$/, "Must be alphanumeric.")
                .min(1)
                .max(30);
            } else if (paymentModeName === "ONLINE") {
              return yup
                .string()
                .required("Reference Number Required")
                .matches(/^[0-9a-zA-Z]+$/, "Must be alphanumeric.")
                .min(1)
                .max(30);
              // .length(20, "Only 6 Digits allowed");
            } else {
              return yup.string().notRequired();
            }
          }),

          bankName: yup
            .object()
            .nullable()
            .typeError("Required")
            .when("paymentMode", (paymentMode) => {
              if (paymentMode !== null) {
                if (
                  paymentMode.label !== "CASH" &&
                  paymentMode.label !== "UPI"
                ) {
                  return yup
                    .object()
                    .nullable()
                    .shape({
                      value: yup.string().required("Select Bank"),
                      label: yup.string().required("Select Bank"),
                    })
                    .required("Select Bank");
                }
              }
            }),
        }),
      )
      .min(1, "Please Add amount Details"),
  };
  const paymentAppointValidation = yup.object().shape(paymentSchema).required();
  const paymentSchemaObj = paymentAppointValidation;

  const methods = useForm({
    mode: "onChange",
    resolver: yupResolver(paymentSchemaObj),
    defaultValues: {
      paymentCart: [
        {
          paymentMode: "",
          amount: "",
          referenceNumber: "",
          bankName: "",
          paymentDate: new Date(),
          upiname: "",
        },
      ],
    },
  });
  /****************************** useForm Destructuring********************************/
  const {
    register,
    handleSubmit,
    reset,
    trigger,
    formState: { errors },
    control,
    getValues,
    setValue,
    watch,
  } = methods;

  const {
    fields,
    append: append,
    remove: remove,
    replace: replace,
  } = useFieldArray({
    control: control,
    name: "paymentCart",
  });
  /****************************** state Variables ********************************/
  const [confirmationOpen, setConfirmationOpen] = React.useState(false);
  const [showAddIcon, setShowAddIcon] = React.useState(false);
  const [netPayableAmountVal, setNetPayableAmountVal] = React.useState(0);
  const [netPayErrorMessage, setNetPayErrorMessage] = React.useState("");
  const [customCashError, setCustomCashError] = React.useState(false);
  const [upiTypes, setUpiTypes] = React.useState();
  const [advancedList, setAdvancedList] = React.useState([]);
  const [bankList, setBankList] = React.useState([]);
  const [paymentModeList, setPaymentModeList] = React.useState([]);
  const [selectedFromDate, setSelectedFromDate] = React.useState(new Date());

  /****************************** other Variables ********************************/
  const watchPaymentCart = watch("paymentCart");
  console.log("paymentModeListpaymentModeListpaymentModeList", paymentModeList);
  let consumeAdvanceFlag = watch("consumeAdvance");
  let refundVal = props.getValues("refundAmount");
  let totalAmount = 0;
  let netPayErrorMessage1 = "";
  let paymentInfoList = [];

  //  onChange get the all field in array
  const controlledPaymentCart = fields.map((field, index) => {
    return {
      ...field,
      ...watchPaymentCart[index],
    };
  });
  /****************************** useEffects ********************************/
  // let payments = "";
  // React.useEffect(() => {
  //   if (watchPaymentCart.length > 0) {
  //     for (let paymentObj of watchPaymentCart) {
  //       if (paymentObj?.paymentMode?.label) {
  //         payments = payments + paymentObj?.paymentMode?.label;
  //       }
  //     }
  //   }
  //   let newPaymentArr = [];
  //   for (let payment of paymentModeList) {
  //     if (
  //       !payments
  //         ?.toLocaleLowerCase()
  //         .includes(payment?.label?.toLocaleLowerCase())
  //     ) {
  //       newPaymentArr.push(payment);

  //       setPaymentModeList(newPaymentArr);
  //     }
  //   }
  // }, [watchPaymentCart]);

  React.useEffect(() => {
    if (controlledPaymentCart.length > 0) {
      let paidAmount = 0;
      for (let paymentObj of controlledPaymentCart) {
        if (paymentObj.amount) {
          paidAmount = parseInt(paidAmount) + parseInt(paymentObj.amount);
        }
      }
      let netPayableAmount = props.getValues("netPayableAmount");
      if (paidAmount > netPayableAmount) {
      }
    }
  }, [props, controlledPaymentCart]);

  React.useEffect(() => {
    getAdvancedDropdown().then((response) => {
      setAdvancedList(response.data.result);
    });

    getBankList().then((response) => {
      setBankList(response.data.result);
    });

    getPaymentMode().then((response) => {
      setPaymentModeList(response.data.result);
      setValue(`paymentCart.0.paymentMode`, response.data.result[1]);
    });

    getUpiType()
      .then((response) => response.data)
      .then((res) => {
        setUpiTypes(res.result);
      });
  }, []);

  React.useEffect(() => {
    setValue(
      `paymentCart.[0].paymentMode`,
      paymentModeList?.filter((val) => val?.label === "CASH")[0],
    );
    setValue(`paymentCart.[0].amount`, props.refundAmount?.toFixed(2));
  }, [props.refundAmount, props.open, paymentModeList]);

  React.useEffect(() => {
    if (props?.selectedRow && props?.open === true) {
      getBillingAdvanceDetails(props?.selectedPatient?.PatientId).then(
        (response) => {
          if (response?.data?.result?.length > 0) {
            console.log("response321", response?.data?.result);
            setBillAdvanceDetailsList(
              response?.data?.result?.map((val) => ({
                ...val,
                Consume: 0,
              })),
            );
          }
        },
      );
    }
  }, [props?.open]);

  /****************************** functions ********************************/
  const handleOpenConfirmation = () => {
    if (netPayErrorMessage1 === "") {
      setConfirmationOpen(true);
    }
  };
  const handleCloseConfirmation = () => {
    setConfirmationOpen(false);
  };

  const resetPaymentModes = () => {
    getPaymentMode().then((response) => {
      setPaymentModeList(response.data.result);
      setValue(`paymentCart.0.paymentMode`, response.data.result[1]);
    });
  };

  //calculate sum of all add button
  function calculateFieldAmountSum() {
    let totalAmount = 0;

    //Calculate the sum of all the paid amounts from various payment modes and store it in the variable totalAmount.
    for (let cartObj of watchPaymentCart) {
      if (watchPaymentCart.length > 1) {
        if (cartObj && cartObj.amount) {
          totalAmount = Number(totalAmount) + Number(cartObj.amount);
        }
      } else if (watchPaymentCart.length === 1 && cartObj.amount) {
        totalAmount = Number(cartObj.amount);
      }
    }

    return totalAmount;
  }

  if (watchPaymentCart[0].amount < props.getValues("refundAmount")) {
    netPayErrorMessage1 = "Total Amount Must Be Equal To Refund Amount";
  } else {
    netPayErrorMessage1 = "";
  }

  //update amount change from amount input filed
  function handleAmountChange() {
    //The below if block is to display the "+" icon only at the first field ; when the length of the field is 1.
    if (watchPaymentCart.length === 1) {
      let firstFieldAmount = Number(watchPaymentCart[0].amount);

      if (firstFieldAmount === props.refundAmount) {
        setShowAddIcon(false);
      } else if (firstFieldAmount < props.refundAmount) {
        setShowAddIcon(true);
      }
    }

    let totalSumVal = calculateFieldAmountSum();
    //This if block is to detect "Total Amount has exceeded netPayVal".
    if (props.refundAmount !== null) {
      if (totalSumVal > props.refundAmount) {
        setNetPayErrorMessage("Amount Exceeds Current Bill Total");
      } else {
        setNetPayErrorMessage("");
      }
    }
  }

  // cash options allow only once
  function detectDuplicateCashOption() {
    let cashCounterIndicator = 0;
    for (let cartArr of watchPaymentCart) {
      if (cartArr.paymentMode.label === "CASH") {
        cashCounterIndicator = cashCounterIndicator + 1;
      }
      if (cashCounterIndicator > 1) {
        setCustomCashError(true);
      } else {
        setCustomCashError(false);
      }
    }
  }

  //function that is called after clicking the submit button of the payment info modal
  function onSubmitDataHandler(data) {
    const paymentCart = data?.paymentCart || [];

    const paymentInfoList = paymentCart.map((formObj) => ({
      amount: formObj?.amount || 0,
      bankId: formObj?.bankName?.id || 0,
      paymentDate: formObj?.paymentDate || "",
      paymentType: formObj?.paymentMode || {
        id: 0,
        label: "",
        value: "",
      },
      referenceNumber: formObj?.referenceNumber || "",
    }));

    const advanceConsumeList =
      billAdvanceDetailsList?.map((val) => ({
        advanceId: val?.AdvanceId,
        advanceDetailId: val?.PatientAdvanceDetails,
        consumeAmount: val?.Consume,
      })) || [];

    console.log(
      "paymentInfoList",
      paymentInfoList,
      "advanceConsumeList",
      advanceConsumeList,
    );

    setPaymentInfo({
      paymentInfoList: paymentInfoList?.filter((val) => val?.amount > 0),
      advanceConsumeList: advanceConsumeList,
    });

    handleOpenConfirmation();
  }

  function saveData(paymentInfo) {
    props.setOpenBackdrop(true);
    props.submitPaymentInfoModal(paymentInfo);
    // props.setOpenBackdrop(false);
    handleCloseConfirmation();
  }

  function appendPaymentField(fieldIndex) {
    let requiredObj = watchPaymentCart[fieldIndex];

    //if the payment mode is "CASH"

    let totalAmountVal = calculateFieldAmountSum();

    //check CASH Payment mode
    if (requiredObj.paymentMode && requiredObj.paymentMode.label === "CASH") {
      if (requiredObj.amount || requiredObj.amount === 0) {
        if (totalAmountVal < props.refundAmount) {
          let nextFieldAmountVal = props.refundAmount - totalAmountVal;

          append({
            paymentMode: null,
            amount: nextFieldAmountVal - totalConsumeAmount,
            referenceNumber: "",
            bankName: null,
            paymentDate: selectedFromDate,
          });
        } else {
          trigger();
        }
      }
    }

    //payment mode is UPI
    if (requiredObj.paymentMode && requiredObj.paymentMode.label === "UPI") {
      if (
        (requiredObj.amount || requiredObj.amount === 0) &&
        requiredObj.referenceNumber
      ) {
        let totalAmountVal = calculateFieldAmountSum();

        if (totalAmountVal < props.refundAmount && customCashError === false) {
          let nextFieldAmountVal = props.refundAmount - totalAmountVal;

          append({
            paymentMode: null,
            amount: nextFieldAmountVal - totalConsumeAmount,
            referenceNumber: "",
            bankName: null,
            paymentDate: selectedFromDate,
          });
        }
      } else {
        trigger();
      }
    }

    //if the payment mode is one of "CHEQUE" , "CREDIT CARD" , "DD" , "DEBIT CARD"
    if (
      requiredObj.paymentMode &&
      (requiredObj.paymentMode.label === "CREDIT CARD" ||
        requiredObj.paymentMode.label === "ECS" ||
        requiredObj.paymentMode.label === "DEBIT CARD" ||
        requiredObj.paymentMode.label === "ONLINE")
    ) {
      if (
        (requiredObj.amount || requiredObj.amount === 0) &&
        requiredObj.referenceNumber &&
        requiredObj.bankName &&
        requiredObj.bankName.label !== " "
      ) {
        let totalAmountVal = calculateFieldAmountSum();

        if (totalAmountVal < props.refundAmount && customCashError === false) {
          let nextFieldAmountVal = props.refundAmount - totalAmountVal;

          append({
            paymentMode: null,
            amount: nextFieldAmountVal - totalConsumeAmount,
            referenceNumber: "",
            bankName: null,
            paymentDate: selectedFromDate,
          });
        }
      } else {
        trigger();
      }
    }

    //if the paymentMode is not selected -- that is when it is undefined ; then at that time also trigger the validation.
    if (!requiredObj.paymentMode) {
      trigger();
    }
    //if the paymentMode is selected as blank ; then at that time also trigger the validation.
    if (requiredObj.paymentMode.label === " ") {
      trigger();
    }
  }

  function removePaymentFieldRow(fieldIndex) {
    let requiredObj = watchPaymentCart[fieldIndex];

    let totalSumVal = 0;
    for (let index = 0; index < watchPaymentCart.length; index++) {
      if (watchPaymentCart.length > 1) {
        if (watchPaymentCart[index] && watchPaymentCart[index].amount) {
          if (index !== fieldIndex) {
            totalSumVal =
              Number(totalSumVal) + Number(watchPaymentCart[index].amount);
          }
        }
      } else if (
        watchPaymentCart.length === 1 &&
        watchPaymentCart[index].amount
      ) {
        totalSumVal = Number(watchPaymentCart[index].amount);
      }
    }
    remove(fieldIndex);
  }

  const renderInput = (row, index, header) => {
    setValue(`consumeAmt${index}`, row?.Consume);
    return (
      <div>
        {header === "Consume" && (
          <input
            type="number"
            name={`consumeAmt${index}`}
            className={`border ${row?.Consume > row?.Balance ? "border-red-500" : "border-black"}  rounded px-1`}
            {...register(`consumeAmt${index}`)}
            onChange={(e) => {
              let tempBillAdvance = [...billAdvanceDetailsList];
              if (e?.target?.value) {
                tempBillAdvance[index].Consume = Number(e?.target?.value);
              } else {
                tempBillAdvance[index].Consume = 0;
              }

              let totalConsumeAmt = 0;
              for (let obj of tempBillAdvance) {
                totalConsumeAmt = totalConsumeAmt += obj?.Consume;
              }
              setTotalConsumeAmount(totalConsumeAmt);
              setBillAdvanceDetailsList(tempBillAdvance);

              replace([
                {
                  amount: props?.refundAmount - totalConsumeAmt,
                  paymentMode: paymentModeList?.filter(
                    (val) => val?.label === "CASH",
                  )[0],
                  referenceNumber: "",
                  bankName: "",
                  paymentDate: selectedFromDate,
                },
              ]);
            }}
          />
        )}
      </div>
    );
  };

  return (
    <div className="px-6">
      <Modal
        open={props.open}
        onClose={() => {
          // props.handleClose();
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={ModalStyle}>
          <div className="grid grid-cols-1 md:grid-cols-1  w-full">
            <CancelPresentationIconButton
              onClick={() => {
                props.handleClose();
                // setValue(`paymentCart.0.paymentMode`, paymentModeList[1]);
                // setValue(`paymentCart.0.amount`, props.refundAmount);

                resetPaymentModes();
                reset();
                setTotalConsumeAmount(0);
                setBillAdvanceDetailsList([]);
              }}
              style={{
                paddingLeft: 10,
              }}
            />
          </div>
          <div className="row">
            <fieldset className="border border-gray-300 text-left   lg:mx-auto lg:px-4 md:ml-0 md:mr-0  rounded   lg:m-2 ">
              <legend className="md:mx-2 md:px-2 lg:px-2 font-bold text-gray-700">
                Bill Information
              </legend>
              <form
                onSubmit={handleSubmit(onSubmitDataHandler)}
                className="grid grid-cols-1 md:grid-cols-1  gap-2"
              >
                <div className=" bg-white px-4 ">
                  <>
                    {/* Paitent Inf0 */}

                    <fieldset className="mx-auto border w-full rounded my-2 bg-gray-100 px-4">
                      <legend className=" rounded-xl">
                        <p className="md:mx-2 md:px-2 lg:px-2 font-bold text-gray-700">
                          Patient Information
                        </p>
                      </legend>
                      <>
                        <div className="mb-2 grid  lg:grid-cols-4 2xl:grid-cols-4 gap-2 p-2 ">
                          <div className="flex items-center gap-2 w-full font-semibold text-sm py-1">
                            <span className="w-24 font-semibold">
                              Patient Name
                            </span>
                            <span>:</span>
                            <span className="text-gray-700 font-normal">
                              {props.selectedPatient &&
                                props.selectedPatient.patientName}
                            </span>
                          </div>
                          <div className="flex items-enter gap-2 w-full font-semibold text-sm py-1">
                            <span className="w-24 lg:w-20 xl:w-14 font-semibold">
                              MR No.
                            </span>
                            <span>:</span>
                            <span className="text-gray-700 font-normal">
                              {props.selectedPatient &&
                                props.selectedPatient.mrNo}
                            </span>
                          </div>

                          <div className="flex items-center gap-2 w-full font-semibold text-sm py-1">
                            <span className="w-24 xl:w-8 font-semibold">
                              Age
                            </span>
                            <span>:</span>
                            <span className="text-gray-700 font-normal">
                              {props.selectedPatient &&
                                props.selectedPatient.age}
                            </span>
                          </div>

                          <div className="flex items-center gap-2 w-full font-semibold text-sm py-1 whitespace-nowrap">
                            <span className=" w-32  ">Net Payable Amount</span>
                            <div className="flex space-x-2 items-center">
                              <span>:</span>
                              <span className="text-gray-700 font-normal">
                                ₹{props.refundAmount}
                              </span>
                            </div>
                          </div>
                        </div>
                      </>
                    </fieldset>

                    {/* Payment Form */}
                    <div className="w-full">
                      <fieldset className="mx-auto border w-full rounded my-3">
                        <legend className="ml-6 my-0 rounded-xl">
                          <p className="md:mx-2 md:px-2 lg:px-2 font-bold text-gray-700">
                            Payment Details
                          </p>
                        </legend>
                        <div className="grid grid-cols-2 gap-x-2 w-full mx-auto px-6 py-2">
                          <div className="w-full space-y-3">
                            {fields.map((field, index) => {
                              let dropdownObj = watch(
                                `paymentCart.[${index}].paymentMode`,
                              );

                              return (
                                <div className="flex space-x-2" key={field.id}>
                                  <DropdownField
                                    control={control}
                                    name={`paymentCart.[${index}].paymentMode`}
                                    error={
                                      watchPaymentCart[index].paymentMode
                                        ?.label === "CASH" &&
                                      customCashError === true
                                        ? {
                                            message: "Cash Allowed only once.",
                                          }
                                        : errors.paymentCart?.[index]
                                            ?.paymentMode
                                    }
                                    label="Payment Type"
                                    dataArray={paymentModeList}
                                    isSearchable={false}
                                    placeholder="Payment Type *"
                                    inputRef={{
                                      ...register(
                                        `paymentCart.[${index}].paymentMode`,
                                        {
                                          onChange: (e) => {
                                            detectDuplicateCashOption();
                                          },
                                        },
                                      ),
                                    }}
                                  />

                                  {dropdownObj &&
                                  dropdownObj.label === "UPI" ? (
                                    <DropdownField
                                      control={control}
                                      error={
                                        errors.paymentCart?.[index]?.upiname
                                      }
                                      name={`paymentCart[${index}].upiname`}
                                      label="Payment Type *"
                                      dataArray={upiTypes}
                                      isSearchable={false}
                                      placeholder="UPI Type*"
                                      inputRef={{
                                        ...register(
                                          `paymentCart[${index}].upiname`,
                                          {
                                            onChange: (e) => {},
                                          },
                                        ),
                                      }}
                                    />
                                  ) : (
                                    ""
                                  )}

                                  <InputField
                                    name={`paymentCart.[${index}].amount`}
                                    error={errors.paymentCart?.[index]?.amount}
                                    variant="outlined"
                                    label="Amount"
                                    control={control}
                                    type="number"
                                    onWheel={(e) => e.target.blur()}
                                    inputRef={{
                                      ...register(
                                        `paymentCart.[${index}].amount`,
                                        {
                                          onChange: (e) => {
                                            handleAmountChange();
                                          },
                                        },
                                      ),
                                    }}
                                  />

                                  {dropdownObj &&
                                  (dropdownObj.label === "DEBIT CARD" ||
                                    dropdownObj.label === "CREDIT CARD" ||
                                    dropdownObj.label === "ECS" ||
                                    dropdownObj.label === "CHEQUE" ||
                                    dropdownObj.label === "UPI" ||
                                    dropdownObj.label === "ONLINE") ? (
                                    <InputField
                                      name={`paymentCart.[${index}].referenceNumber`}
                                      variant="outlined"
                                      label="Reference Number"
                                      control={control}
                                      error={
                                        errors.paymentCart?.[index]
                                          ?.referenceNumber
                                      }
                                      onWheel={(e) => e.target.blur()}
                                    />
                                  ) : null}

                                  {dropdownObj &&
                                  (dropdownObj.label === "DEBIT CARD" ||
                                    dropdownObj.label === "CREDIT CARD" ||
                                    dropdownObj.label === "ECS" ||
                                    dropdownObj.label === "CHEQUE" ||
                                    dropdownObj.label === "ONLINE") ? (
                                    <DropdownField
                                      control={control}
                                      name={`paymentCart.[${index}].bankName`}
                                      label="Bank Name"
                                      dataArray={bankList}
                                      isSearchable={true}
                                      placeholder="Bank Name *"
                                      searchIcon={true}
                                      error={
                                        errors.paymentCart?.[index]?.bankName
                                      }
                                    />
                                  ) : null}

                                  {/* Date Picker Component */}
                                  {dropdownObj &&
                                  (dropdownObj.label === "DEBIT CARD" ||
                                    dropdownObj.label === "CREDIT CARD" ||
                                    dropdownObj.label === "ECS" ||
                                    dropdownObj.label === "CHEQUE" ||
                                    dropdownObj.label === "ONLINE") ? (
                                    <>
                                      <DatePickerFieldNew
                                        control={control}
                                        name={`paymentCart[${index}].paymentDate`}
                                        label="From Date"
                                        value={new Date()}
                                        disableFuture={true}
                                        disablePast={false}
                                        inputFormat="dd-MM-yyyy"
                                        inputRef={{
                                          ...register(
                                            `paymentCart[${index}].paymentDate`,
                                            {
                                              onChange: (e) => {
                                                if (
                                                  e.target.value.toString()
                                                    .length === 55
                                                ) {
                                                  let dateVal = format(
                                                    e.target.value,
                                                    "yyyy-MM-dd",
                                                  );
                                                  let timeVal =
                                                    dateVal +
                                                    "T" +
                                                    "00:00:00:000Z";
                                                  setSelectedFromDate(timeVal);
                                                }
                                              },
                                            },
                                          ),
                                        }}
                                      />
                                      {/***  <Controller
                                        control={control}
                                        defaultValue={new Date()}
                                        rules={{
                                          required: true,
                                        }}
                                        render={({ field }) => (
                                          <LocalizationProvider
                                            dateAdapter={AdapterDateFns}
                                          >
                                            <DatePicker
                                              // open={openDate}
                                              // onOpen={() => setOpenDate(true)}
                                              // onClose={() => setOpenDate(false)}
                                              inputProps={{
                                                readOnly: true,
                                              }}
                                              // disablePast
                                              // readOnly={true}

                                              renderInput={(props) => (
                                                <TextField
                                                  {...props}
                                                  type="date"
                                                  variant="outlined"
                                                  label="Registration Date"
                                                  name="paymentDate"
                                                  InputLabelProps={{
                                                    shrink: true,
                                                  }}
                                                  fullWidth
                                                  size="small"
                                                  // onClick={(e) => setOpenDate(true)}
                                                />
                                              )}
                                              inputFormat="dd/MM/yyyy"
                                              disablePast
                                              {...field}
                                              onAccept={(e) => {
                                                // getNewRegDate(e, index);
                                              }}
                                              // error={
                                              //   errors.paymentDetails?.[index]
                                              //     ?.paymentDate
                                              // }
                                              // helperText={errors.paymentDate?.message}
                                            />
                                          </LocalizationProvider>
                                        )}
                                        name={`paymentCart.[${index}].paymentDate`}
                                      />*/}
                                    </>
                                  ) : null}

                                  <div className="flex items-center">
                                    {showAddIcon === true && index === 0 ? (
                                      <div className="flex items-center">
                                        <RemoveOutlinedIcon className="mt-2 mx-1 rounded-full border-2 border-gray-400 text-gray-400" />
                                        <AddOutlinedIcon
                                          className="mt-2 mx-1  rounded-full border-2 border-cyan-600"
                                          onClick={() => {
                                            if (netPayErrorMessage === "") {
                                              appendPaymentField(index);
                                            }
                                          }}
                                        />
                                      </div>
                                    ) : null}

                                    {index > 0 && fields.length > 1 ? (
                                      <>
                                        <RemoveOutlinedIcon
                                          className="mt-2 mx-1 rounded-full border-2 border-red-600"
                                          onClick={() => {
                                            if (fields.length > 1) {
                                              removePaymentFieldRow(index);
                                            }
                                          }}
                                        />
                                        {fields.length < 4 ? (
                                          <AddOutlinedIcon
                                            className="mt-2 mx-1  rounded-full border-2 border-cyan-600"
                                            onClick={() => {
                                              if (netPayErrorMessage === "") {
                                                appendPaymentField(index);
                                              }
                                            }}
                                          />
                                        ) : null}
                                      </>
                                    ) : null}
                                  </div>
                                  {/* </Grid> */}
                                </div>
                              );
                            })}
                            <span className=" text-red-500">
                              {netPayErrorMessage}
                            </span>
                          </div>
                          <div>
                            {billAdvanceDetailsList?.length > 0 && (
                              <CommonTransactionTable
                                dataResult={billAdvanceDetailsList}
                                tableClass={"max-h-40"}
                                removeHeaders={["AdvanceId"]}
                                renderInput={renderInput}
                                editableColumns={["Consume"]}
                                highlightRow={false}
                              />
                            )}
                          </div>
                        </div>
                      </fieldset>

                      <Grid
                        item
                        lg={1.5}
                        md={1.5}
                        className="flex justify-end gap-2 py-2"
                      >
                        <CommonButton
                          label="Cancel"
                          className="border border-customRed text-customRed"
                          onClick={() => {
                            props.handleClose();
                            reset();
                            resetPaymentModes();
                            setValue(
                              `paymentCart.0.paymentMode`,
                              paymentModeList[1],
                            );
                            setValue(
                              `paymentCart.0.amount`,
                              props.refundAmount,
                            );
                          }}
                        />
                        <CommonButton
                          className="bg-green-700 text-white"
                          label="Save"
                          type="submit"
                          onClick={() => {
                            //sum of all the amounts in the field
                            let totalOfFieldAmounts = calculateFieldAmountSum();

                            if (
                              netPayErrorMessage === "" &&
                              totalOfFieldAmounts === netPayableAmountVal
                            ) {
                              //open the confirmation modal
                              setConfirmationOpen(true);
                            }
                          }}
                        />
                      </Grid>
                    </div>
                  </>
                </div>
              </form>
            </fieldset>
            <CommonBackDrop openBackdrop={props.openBackdrop} />
          </div>
        </Box>
      </Modal>
      {confirmationOpen ? (
        <ConfirmationModal
          confirmationOpen={confirmationOpen}
          confirmationHandleClose={handleCloseConfirmation}
          confirmationSubmitFunc={() => {
            saveData(paymentInfo);
          }}
          confirmationLabel="Confirmation "
          confirmationMsg="Save Payment Details?"
          confirmationButtonMsg="Save Payment"
        />
      ) : null}
    </div>
  );
}
